import type { FC } from 'react';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { httpServices } from '@/api/client';
import CenteredSpin from '@/components/CenteredSpin';
import { AppConstants, COOKIE_MAX_AGE } from '@/utils/constants';

const LoadingPage: FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const requestReloadFromParent = () => {
        window.parent.postMessage(
          { type: AppConstants.reloadMessage },
          AppConstants.SAAS_DOMAIN,
        );
      };

      const handleMessage = async (event: MessageEvent) => {
        const { data, origin } = event;
        if (data?.type !== 'reload' || origin !== AppConstants.SAAS_DOMAIN)
          return;

        try {
          const token = data?.token;

          if (token) {
            document.cookie = `access_token=${token}; path=/; max-age=${COOKIE_MAX_AGE}; secure; samesite=strict; domain=${AppConstants.DOMAIN}`;
            httpServices.llmService.updateToken(token);
            httpServices.saasService.updateToken(token);
            navigate('/');
          } else {
            requestReloadFromParent();
          }
        } catch (error) {
          requestReloadFromParent();
        }
      };

      window.addEventListener('message', handleMessage);
      if (searchParams?.get('reloadToken') === 'true') {
        window.parent.postMessage(
          { type: AppConstants.reloadMessage },
          AppConstants.SAAS_DOMAIN,
        );
      }
      return () => {
        window.removeEventListener('message', handleMessage);
      };
    }
  }, [navigate, searchParams]);

  return <CenteredSpin />;
};

export default LoadingPage;
